export const LOADMAP = "LOADMAP";
export const GETMAPINSTANCE = "GETMAPINSTANCE";